import styled from '../../theme/styled-with-theme';
import { pxToRem } from '../../styles/utils';
import { mediaQueries } from '../../styles/media-queries';

import { ColorToken } from '../../theme/tokens/color';

import { Box } from '../Box';
import { TextWithOptions } from '../Text/TextWithOptions';
import { BlockContainer } from '../Layout';
import { GlImage } from '../Image';

import {
  ParagraphWithLineBreaks as RichTextParagraph,
  InlineAnchor as RichInlineAnchor,
  handleColorType
} from '../RichText/styles';

export const CustomBlockContainer = styled(BlockContainer)`
  ${mediaQueries.tablet} {
    display: flex;

    [data-testid='social-proof-bar'] {
      width: 100%;
      max-width: initial;
      margin-top: ${pxToRem(24)};
    }
  }
`;

export const RelativeBox = styled(Box)`
  position: relative;
`;

export const CTAText = styled(TextWithOptions)`
  margin: 0 auto;
  padding-bottom: ${({ theme }) => theme.spacing.m};
`;

export const MobileImage = styled(GlImage)`
  width: ${pxToRem(337)};
  height: ${pxToRem(408)};

  ${mediaQueries.tablet} {
    display: none;
  }
`;

export const DesktopImage = styled(GlImage)<{ visibility: string }>`
  visibility: ${({ visibility }) => visibility};
  border-radius: ${({ theme }) => theme.borderRadius.milestoneShape};
  margin: 0 !important;

  ${mediaQueries.tablet} {
    height: ${pxToRem(397)} !important;
    min-height: initial !important;
  }

  ${mediaQueries.desktop} {
    height: ${pxToRem(560)} !important;
    min-height: initial !important;
  }
`;

export const InlineAnchor = styled(RichInlineAnchor, {
  shouldForwardProp: (prop) => prop !== 'hoverColor'
})<{
  hoverColor?: ColorToken;
}>`
  ${({ theme, hoverColor = 'lightButton' }) => `
    &:hover {
      color: ${handleColorType(theme, hoverColor)};
    }

    ${mediaQueries.desktop} {
      &:hover {
        color:
          ${handleColorType(theme, hoverColor)};
      }
    }
  `}
`;

export const PrivacyPolicyWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const ParagraphWithLineBreaks = styled(RichTextParagraph)`
  max-width: ${pxToRem(272)};

  ${mediaQueries.tablet} {
    text-align: left;
  }

  ${mediaQueries.desktop} {
    min-width: 0;
    max-width: ${pxToRem(332)};
  }
`;

export const CaptionWithLineBreaks = styled(RichTextParagraph)`
  max-width: ${pxToRem(272)};
  color: #757575;

  ${mediaQueries.tablet} {
    text-align: center;
  }

  ${mediaQueries.desktop} {
    min-width: 0;
    max-width: ${pxToRem(496)};
  }
`;

export const AdditionalContentWrapper = styled('div')`
  margin-top: ${pxToRem(20)};
  display: flex;
  white-space: pre;
  font-size: ${pxToRem(14)};
  max-width: 21rem;
  align-items: flex-start;
`;
export const StyledIcon = styled('img')`
  margin-right: ${pxToRem(6)};
  margin-top: ${pxToRem(-1)};

  ${mediaQueries.tablet} {
    margin-top: ${pxToRem(1)};
  }
`;
